import { render, staticRenderFns } from "./SignIn.vue?vue&type=template&id=ec70ab98&scoped=true"
import script from "./SignIn.vue?vue&type=script&lang=js"
export * from "./SignIn.vue?vue&type=script&lang=js"
import style0 from "./SignIn.vue?vue&type=style&index=0&id=ec70ab98&prod&lang=scss"
import style1 from "./SignIn.vue?vue&type=style&index=1&id=ec70ab98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec70ab98",
  null
  
)

export default component.exports